import { render, staticRenderFns } from "./WorkforceEmployeesPage.vue?vue&type=template&id=5b15d743&"
import script from "./WorkforceEmployeesPage.vue?vue&type=script&lang=js&"
export * from "./WorkforceEmployeesPage.vue?vue&type=script&lang=js&"
import style0 from "./WorkforceEmployeesPage.vue?vue&type=style&index=0&id=5b15d743&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports